import PropTypes from 'prop-types';
import Spinner from 'Components/Atoms/Spinner';

export default function SnackbarSpinner({ size = 24 }) {
    return <Spinner size={size} color="#5543C7" className="block ml-auto mr-3" />;
}

SnackbarSpinner.propTypes = {
    size: PropTypes.number,
};
